export default __webpack_public_path__ + "assets/copy-paste-component.e30e0424.svg";